
import { useTranslation } from 'react-i18next';

export function HeroSection() {
  const { t } = useTranslation();
  
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 py-20 sm:py-32">
        <div className="text-center max-w-5xl mx-auto space-y-6 sm:space-y-8">
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extralight text-white leading-tight tracking-[0.05em] sm:tracking-[0.1em]">
            {t('heroTitle')}
          </h1>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 sm:bottom-12 left-1/2 transform -translate-x-1/2 z-10">
        <div className="w-6 h-10 sm:w-8 sm:h-12 border-2 border-white/30 rounded-full flex justify-center pt-2">
          <div className="w-1 h-2 sm:w-1.5 sm:h-3 bg-white/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}
